import React from 'react'
import PanelSearchCnpj from '../search/PanelSearchCnpj'
import TableProductSearch from './TableProductSearch'

function PanelProductSearchCnpj({
  cnpj,
}) {
  return (
    <PanelSearchCnpj
      cnpj={cnpj}
      TableComponent={TableProductSearch} />
  )
}

export default (PanelProductSearchCnpj)